Ext.define('SA.VectorMapThematicMapTileSourcesUrls', {
    singleton: true,

    get(modelState) {
        return {locations: SA.VectorMapChoroplethLocationsTileSourceUrls.get(modelState)};
    }
});